module.exports = __webpack_public_path__ + "img/APUA_APUA_MONOLITH.65234242.jpg";